<div class="portfolios-list">
  @for (portfolio of portfoliosList; track portfolio.portfolioId; let i = $index; let last = $last) {
    <liberro-investment-tile
      [investment]="portfolio"
      (portfolioSelected)="selectPortfolio(portfolio.portfolioId)"
    ></liberro-investment-tile>
    @if (!last) {
      <nz-divider
        class="no-progress-divide"
        [class.contains-instrument-will-be-removed]="portfolio.containesWillBeRemovedInstrument || portfoliosList[i + 1]?.containesWillBeRemovedInstrument"
      ></nz-divider>
    }
  }
</div>

@if (showViewMore) {
  <div class="show-more-link-container">
    <liberro-show-more-link
      [label]="'global.button.allMyInvestments' | translate"
      prefixIcon="chart-square.svg"
      (linkClicked)="viewMorePortfolios()"
    ></liberro-show-more-link>
  </div>
}
